'use client';

import type { ReactNode } from 'react';
import { AiBrowserStreamingFrame } from '../../AiBrowserStreamingFrame';
import type { StreamingContentProps } from '../../tool-config-types';

export const renderBrowserStreamingContent = (
  props: StreamingContentProps,
): ReactNode => (
  <AiBrowserStreamingFrame
    streamingId={props.toolCallId}
    onSSESubscribe={props.onSSESubscribe}
    onOpenInMainContent={props.onOpenBrowserStreamInMainContent}
  />
);
